import { Injectable } from "@angular/core";

@Injectable({ providedIn: 'root' })
export class FileSanitizeService {

    private static readonly INVALID_FILENAME_CHARS = /[^A-Za-z0-9 !#&'+\-.^_`~]/g;

    /**
     * Ersetzt unerlaubte Zeichen im Dateinamen durch Unterstrich.
     */
    replaceInvalidFilenameChars(fileName: string | null | undefined): string {
        if (!fileName) {
            return '_';
        }
        return fileName.replace(FileSanitizeService.INVALID_FILENAME_CHARS, '_');
    }

}